module.exports = "/fonts/Flaticon2.ttf?eafcbac04cdb0a39fe38a36ebd786290";